/** Angles de départ et de fin (degrés, y vers le bas, sens des aiguilles d'une montre) du cône d'une attaque de mêlée centré sur `dir`. */
export function meleeArcDegrees(dir: { x: number; y: number }, halfAngleDeg: number): { start: number; end: number } {
  const center = (Math.atan2(dir.y, dir.x) * 180) / Math.PI;
  return { start: center - halfAngleDeg, end: center + halfAngleDeg };
}
